import { Entry } from '../Entry'

export function Entry20211012() {
  return (
    <Entry title="12/10/2021 - v3.0.0-beta-10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12289/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
